import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistedStore, store } from "./redux/store";
import { PersistGate } from "reduxjs-toolkit-persist/integration/react";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { Slide, ToastContainer } from "react-toastify";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Loading from "./components/common/Loading";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ToastContainer transition={Slide} newestOnTop />
    <BrowserRouter>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_APP_ID}>
        <PersistGate
          loading={<Loading customText={""} />}
          persistor={persistedStore}
        >
          <App />
        </PersistGate>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </Provider>

  // Maintanace Page

  // <div style={{
  //   textAlign: "center",
  //   padding: "150px",
  //   fontFamily: "Helvetica, sans-serif",
  //   fontSize: "20px",
  //   color: "#333",
  //   background: "linear-gradient(135deg,rgb(159, 0, 0) 30%, #ffffff 70%)",
  //   minHeight: "100vh",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // }}>
  //   <article style={{
  //     display: "block",
  //     textAlign: "left",
  //     width: "650px",
  //     margin: "0 auto",
  //     padding: "20px",
  //     background: "rgba(255, 255, 255, 0.8)",
  //     borderRadius: "10px",
  //     boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  //   }}>
  //     <h1 style={{
  //       fontSize: "50px",
  //       color: "#b30000",
  //     }}>Maintenance Underway</h1>
  //     <div style={{
  //       color: "#333",
  //     }}>
  //       <p>
  //         Our system will be undergoing maintenance from <b>10:30 PM on March 2, 2025,</b> to <b>8:00 AM on March 3, 2025</b>.
  //         We apologize for any inconvenience and appreciate your patience. Thank you for your understanding!"
  //       </p>
  //       <p>&mdash; The Team</p>
  //     </div>
  //   </article>
  // </div>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
